module.exports = __webpack_public_path__ + "c4a63c2ce626758a57d7cf53fa737d33.svg";